// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const ImmutableToJS = require('client-v2/common/components/immutable-to-js')
const routerActions = require('client-v2/common/state/router/actions')
// Sibling imports
const shareModalActions = require('../actions')
const shareModalSelectors = require('../selectors')
const ShareModalShareFriends = require('./share-friends-dumb')

function mapStateToProps() {
  const isVisibleSelector = shareModalSelectors.createIsFriendsVisibleSelector()
  const friendsSearchSelector = shareModalSelectors.createFriendsSearchSelector()
  return function (state) {
    const { shareModal } = state
    return {
      friends: friendsSearchSelector(state),
      friendsState: shareModal.friendsState,
      isVisible: isVisibleSelector(state),
      searchText: shareModal.searchText,
      submitState: shareModal.submitState,
      user: state.user
    }
  }
}

const mapDispatchToProps = {
  onFriendClick: shareModalActions.toggleFriend,
  onFriendsSearch: shareModalActions.setSearchText,
  onFriendsShare: shareModalActions.shareWithFriends,
  onNavigate: routerActions.navigate
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  ImmutableToJS(
    ShareModalShareFriends
  )
)
